import axiosInstance from './axiosConfig';

export type PatientDeletionResponse = {
  mongo: {
    status: 'deleted' | 'not_found' | 'failed';
    counts: Record<string, number>;
  };
  postgres: {
    status: 'deleted' | 'not_found' | 'failed';
    counts: Record<string, number>;
  };
  status: 'ok' | 'partial' | 'failed';
  attemptId: string;
};

type ApiEnvelope<T> = {
  status: boolean;
  meta: Record<string, unknown>;
  result: T;
};

export async function requestPatientDeletion(
  userId: string,
  confirm: string
): Promise<PatientDeletionResponse> {
  const { data } = await axiosInstance.post<
    ApiEnvelope<PatientDeletionResponse>
  >('/admin/patient-deletion', { userId, confirm, userType: 'patient' });
  return data.result;
}

export async function requestAdminDeletion(
  userId: string,
  confirm: string
): Promise<PatientDeletionResponse> {
  const { data } = await axiosInstance.post<
    ApiEnvelope<PatientDeletionResponse>
  >('/admin/admin-deletion', { userId, confirm, userType: 'admin' });
  return data.result;
}
